import { render, staticRenderFns } from "./PalmCove.vue?vue&type=template&id=5eb18a00&scoped=true&"
import script from "./PalmCove.vue?vue&type=script&lang=ts&"
export * from "./PalmCove.vue?vue&type=script&lang=ts&"
import style0 from "./PalmCove.vue?vue&type=style&index=0&id=5eb18a00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb18a00",
  null
  
)

export default component.exports